import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'

import { GetCallAnsweringCustomerInfo, GetCallAnsweringInstruction, editCallReport, getAllOperatorRequest, getCallHistoryByExtension, getInstructionList, getLoginAssRequest, getِAttachmentById, getِCallReportByCallId, saveCallReport } from '../apiRequests/reportRequest'


function* handleGetCallHistoryByExtension(action) {
    try {
        const response = yield call(getCallHistoryByExtension, action.params, action.pageData)
        yield put({
            type: types.GET_CALL_HISTORY_BY_EXTENSION_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CALL_HISTORY_BY_EXTENSION_ERROR,
            error: error.response,
        })
    }
}
function* handleGetCallInstruction(action) {
    try {
        const response = yield call(GetCallAnsweringInstruction, action.params)
        yield put({
            type: types.GET_CALL_INSTRuCTION_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CALL_INSTRuCTION_ERROR,
            error: error.response,
        })
    }
}

function* handleGetCallCustomerInfo(action) {
    try {
        const response = yield call(GetCallAnsweringCustomerInfo, action.params)
        yield put({
            type: types.GET_CALL_CUSTOMER_INFO_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CALL_CUSTOMER_INFO_ERROR,
            error: error.response,
        })
    }
}


function* handleGetInstructionList(action) {
    try {
        const response = yield call(getInstructionList, action.params)
        yield put({
            type: types.GET_INSTRUCTION_LIST_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_INSTRUCTION_LIST_ERROR,
            error: error.response,
        })
    }
}
function* handleGetAttachmentLink(action) {
    try {
        const response = yield call(getِAttachmentById, action.params)
        yield put({
            type: types.GE_ATTACHMENT_LINK_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GE_ATTACHMENT_LINK_ERROR,
            error: error.response,
        })
    }
}

function* handleGetCallReportRequest(action) {
    try {
        const response = yield call(getِCallReportByCallId, action.params)
        yield put({
            type: types.GET_CALL_REPORT_BY_ID_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CALL_REPORT_BY_ID_ERROR,
            error: error.response,
        })
    }
}


function* handleSaveCallRequest(action) {
    try {
        const response = yield call(saveCallReport, action.params)
        yield put({
            type: types.SAVE_CALL_REPORT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.SAVE_CALL_REPORT_ERROR,
            error: error.response,
        })
    }
}


function* handleEditCallRequest(action) {
    try {
        const response = yield call(editCallReport, action.params)
        yield put({
            type: types.UPDATE_CALL_REPORT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.UPDATE_CALL_REPORT_ERROR,
            error: error.response,
        })
    }
}


function* handleGetLoginAsRequest(action) {
    try {
        const response = yield call(getLoginAssRequest, action.params)
        yield put({
            type: types.GET_LOGIN_AS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_LOGIN_AS_ERROR,
            error: error.response,
        })
    }
}


function* handleGetAllOperatorsRequest() {
    try {
        const response = yield call(getAllOperatorRequest)
        yield put({
            type: types.GET_ALL_OPERATORS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_ALL_OPERATORS_ERROR,
            error: error.response,
        })
    }
}


function* watcherReportSaga() {
    yield takeEvery(types.GET_CALL_HISTORY_BY_EXTENSION_REQUEST, handleGetCallHistoryByExtension)
    yield takeEvery(types.GET_CALL_INSTRuCTION_REQUEST, handleGetCallInstruction)
    yield takeEvery(types.GET_CALL_CUSTOMER_INFO_REQUEST, handleGetCallCustomerInfo)
    yield takeEvery(types.GET_INSTRUCTION_LIST_REQUEST, handleGetInstructionList)
    yield takeEvery(types.GE_ATTACHMENT_LINK_REQUEST, handleGetAttachmentLink)
    yield takeEvery(types.GET_CALL_REPORT_BY_ID_REQUEST, handleGetCallReportRequest)
    yield takeEvery(types.SAVE_CALL_REPORT_REQUEST, handleSaveCallRequest)
    yield takeEvery(types.UPDATE_CALL_REPORT_REQUEST, handleEditCallRequest)
    yield takeEvery(types.GET_LOGIN_AS_REQUEST, handleGetLoginAsRequest)
    yield takeEvery(types.GET_ALL_OPERATORS_REQUEST, handleGetAllOperatorsRequest)






}

export default watcherReportSaga
